import { execute } from '@/api/execute'
import { GET, PUT, POST } from '@/api/types'
import { addQueryParams } from '@/util/index.js'

const ENDPOINT = 'dashboard/users'

export default {
  list (params = {}) {
    return execute(GET, addQueryParams(`${ENDPOINT}/`, params))
  },

  create (payload) {
    return execute(POST, `${ENDPOINT}/create/`, payload)
  },

  getById (id) {
    return execute(GET, `${ENDPOINT}/${id}/`)
  },

  updateById (id, payload) {
    return execute(PUT, `${ENDPOINT}/${id}/`, payload)
  },

  updatePasswordById (id, payload) {
    return execute(PUT, `${ENDPOINT}/${id}/password/`, payload)
  }
}
